import { render, staticRenderFns } from "./customerContact.vue?vue&type=template&id=9b89e556&scoped=true&"
import script from "./customerContact.vue?vue&type=script&lang=js&"
export * from "./customerContact.vue?vue&type=script&lang=js&"
import style0 from "./customerContact.vue?vue&type=style&index=0&id=9b89e556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b89e556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b89e556')) {
      api.createRecord('9b89e556', component.options)
    } else {
      api.reload('9b89e556', component.options)
    }
    module.hot.accept("./customerContact.vue?vue&type=template&id=9b89e556&scoped=true&", function () {
      api.rerender('9b89e556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commodityBoard/components/customerContact.vue"
export default component.exports